// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"71":"766991d8","313":"846d4ab9","475":"917dca5d","516":"a6c8e124","739":"aad84ba1","761":"acfbe83e","815":"aa85b041","960":"4e706dac"}[chunkId] + ".js";
};